module.exports = __webpack_public_path__ + "static/media/asset-tracker.65db27f6.svg";